<template>
  <qx-card-form title="联系人信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="split"></section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '第一联系人',
            value: 'linkMan1',
            placeholder: '请输入第一联系人',
            type: 'input',
          },
          {
            label: '联系人电话',
            value: 'linkManPhone1',
            placeholder: '请输入第一联系人电话',
            type: 'input',
          },
          {
            value: 'split',
            allCustom: true,
          },
          {
            label: '第二联系人',
            value: 'linkMan2',
            placeholder: '请输入第二联系人',
            type: 'input',
          },
          {
            label: '联系人电话',
            value: 'linkManPhone2',
            placeholder: '请输入第二联系人电话',
            type: 'input',
          },
        ],
      },
    };
  },
  methods: {

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
